import React from 'react';
import { Check } from 'lucide-react';

export interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: React.ReactNode;
  error?: string;
}

const Checkbox: React.FC<CheckboxProps> = ({ label, error, className = '', id, ...rest }) => {
  const errorId = error ? `${id}-error` : undefined;
  const borderColor = error ? 'border-error' : 'border-default';
  return (
    <div>
      <label
        htmlFor={id}
        className={`inline-flex items-center gap-2 cursor-pointer select-none text-sm text-pt-forest ${rest.disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
      >
        <span className="relative inline-flex shrink-0">
          <input
            id={id}
            type="checkbox"
            aria-invalid={!!error}
            aria-describedby={errorId}
            className={`peer h-4 w-4 appearance-none border ${borderColor} rounded-sm bg-input focus:outline-none focus:ring-2 focus:ring-pt-gold checked:bg-pt-forest checked:border-pt-forest disabled:cursor-not-allowed transition-colors duration-[var(--motion-duration-fast)] ${className}`.trim()}
            {...rest}
          />
          <Check
            size={12}
            strokeWidth={3}
            className="absolute left-0.5 top-0.5 text-pt-cream opacity-0 peer-checked:opacity-100 pointer-events-none"
            aria-hidden
          />
        </span>
        {label && <span>{label}</span>}
      </label>
      {error && (
        <p id={errorId} className="text-xs text-error mt-1 ml-6">
          {error}
        </p>
      )}
    </div>
  );
};

export default Checkbox;
